module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "btn btn__green",
    on: {
      "click": function($event) {
        return _vm.jumpAddOptionId({
          jump: _vm.jump
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('edit.sidebar.add_answer')))])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-938d3420!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/buttons/AddOption.vue
 ** module id = 885
 ** module chunks = 1
 **/